<!-- TODO: We need to further simplify this when time permits -->

<div class="upsell-item-content" [ngClass]="useVerticalLayout ? 'vertical' : 'horizontal'">

  <div class="hidden-sm hidden-md hidden-lg" *ngIf="!useVerticalLayout">
    <img class='img-fluid full-width' ftsPicture #pictureRef1='pictureRef' [imgSrc]='imageSrc' alt="{{panelItem.label || panelItem.name}}"/>
    <fts-ghost-element *ngIf='!useVerticalLayout && imageSrc  && !pictureRef1?.isLoaded' [height]="220"></fts-ghost-element>
  </div>
  <div class="hidden-xs horizontal-image-wrapper" *ngIf="!useVerticalLayout">
    <img class="img-fluid full-width" ftsPicture #pictureRef2='pictureRef' [imgSrc]='imageSrc' alt="{{panelItem.label || panelItem.name}}">
    <fts-ghost-element *ngIf='!useVerticalLayout && imageSrc  && !pictureRef2?.isLoaded' [height]="220"></fts-ghost-element>
  </div>

  <div class="item-info primary-bg-color primary-text-color">
    <h2 class="font-secondary fw-500 no-margin padded-horiz-15 padded-vert-15 item-info-title"
        [ngClass]="useVerticalLayout ? 'secondary-bg-color secondary-text-color' : 'no-bottom-margin no-bottom-padding'">
      {{title}}
    </h2>

    <div [ngClass]="{'vertical-card-item-container': useVerticalLayout}">

      <div class="padded-horiz-15 padded-vert-15" *ngIf="!useVerticalLayout">
        <h3 class='font-secondary no-top-margin no-bottom-margin panel-item-name' [attr.aria-label]="panelItem.label || panelItem.name">
          {{panelItem.label || panelItem.name}}<sup *ngIf="panelItem.labelSymbol">{{panelItem.labelSymbol}}</sup>
        </h3>
        <p class='margin-top-10 fw-500 calories-display' *ngIf='calories'>{{calories}}</p>
      </div>
      <ng-container *ngIf="useVerticalLayout">
        <img class='img-fluid full-width' ftsPicture #pictureRef3='pictureRef' [imgSrc]='imageSrc' alt="{{panelItem.label || panelItem.name}}"/>
        <fts-ghost-element *ngIf='useVerticalLayout && imageSrc  && !pictureRef3?.isLoaded' [height]="220"></fts-ghost-element>
      </ng-container>

      <div class="overlay padded-horiz-15 padded-vert-15" *ngIf="useVerticalLayout"
           [ngClass]="{'no-bottom-padding': calories}">
        <h3 class='font-secondary no-top-margin no-bottom-margin panel-item-name' [attr.aria-label]="panelItem.label || panelItem.name">
          {{panelItem.label || panelItem.name}}<sup *ngIf="panelItem.labelSymbol">{{panelItem.labelSymbol}}</sup>
        </h3>
        <p class='margin-top-10 fw-500 calories-display' *ngIf='calories'>{{calories}}</p>
      </div>

      <div *ngIf="!hideDescription" class="item-description panel-item-description flex-1 padded-horiz-15 padded-vert-15 no-bottom-padding" [ngClass]="{'overlay': useVerticalLayout}">
        <fts-read-more *ngIf="(breakPointService.isXSMobile$ | async)" [text]="panelItem.description" [limit]></fts-read-more>
        <fts-read-more *ngIf="!(breakPointService.isXSMobile$ | async)" [text]="panelItem.description" [limit]="300"></fts-read-more>
      </div>

      <div class='flex-1 upsell-item-footer' [ngClass]="{'overlay': useVerticalLayout}">

        <div class="padded-horiz-15 pt-2" [ngClass]="{'pb-2': panelItem.sizePrices.length !== 1, 'padding-bottom-3': panelItem.sizePrices.length === 1}" *ngIf="upsellItem.unsatisfiedIngredientChoice?.name">
          <fts-single-ingredient-choice
              [unsatisfiedIngredientChoice]="upsellItem.unsatisfiedIngredientChoice"
              [selectedSizePrice]="selectedSizePrice"
              (ingredientChange)="onIngredientChange($event)"
              (qualifierChange)="onQualifierChange($event)">
            </fts-single-ingredient-choice>
        </div>

        <div class="padded-horiz-15 pb-2 text-left">
          <fts-size-prices
            [itemName]='panelItem.name'
            [sizePrices]="panelItem.sizePrices"
            [(selectedSizePrice)]="selectedSizePrice"
            (selectedSizePriceChange)='onSizeChange($event)'></fts-size-prices>
        </div>

        <div class='card-controls padded-horiz-15 padded-vert-15'>
          <div class='quantity'>
            <fts-quantities [label]="'component.quantities.quantity_label' | translate" [(selectedQuantity)]="selectedQuantity"
                            [minimumQuantity]="upsellItem?.orderableItem?.minimumQuantity"></fts-quantities>
          </div>

          <fts-size-price-button
            [menuItemsLayout]="menuItemsLayoutEnum.CardMenu"
            [isUpsell]="true"
            [panelItem]='panelItem'
            [quantity]="selectedQuantity"
            [sizePrice]='selectedSizePrice'
            [upsellType]="upsellType"
            [upfrontIngredient]='selectedUpfrontIngredient'
            [upfrontChoice]='upsellItem?.unsatisfiedIngredientChoice?.name'
            [upfrontQualifiers]='upfrontQualifiers'
          ></fts-size-price-button>

        </div>

      </div>

    </div>
  </div>
</div>
